import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
/** Keeps dashboard search in sync between the shell bar and the inbox (URL `?q=`). */
export function useDashboardSearch() {
    const [searchParams, setSearchParams] = useSearchParams();
    const search = useMemo(() => searchParams.get('q') ?? '', [searchParams]);
    const setSearch = useCallback((value) => {
        const next = new URLSearchParams(searchParams);
        const trimmed = value.trim();
        if (trimmed)
            next.set('q', trimmed);
        else
            next.delete('q');
        setSearchParams(next, { replace: true });
    }, [searchParams, setSearchParams]);
    return { search, setSearch };
}
